import { render, staticRenderFns } from "./FacilitiesSortingSelect.vue?vue&type=template&id=5b7dd5d6&"
import script from "./FacilitiesSortingSelect.vue?vue&type=script&lang=js&"
export * from "./FacilitiesSortingSelect.vue?vue&type=script&lang=js&"
import style0 from "./FacilitiesSelect.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
